export default [{
  header: 'Partners',
  icon: 'PackageIcon',
  i18n: 'Apps',
  items: [
    {
      url: '/partners/panel',
      name: 'Panel',
      icon: 'GridIcon',
      slug: 'panel',
      permiso: 'WB000'
    }
  ]
}];
